const icon = new URL('../../icons/pie-chart.png', import.meta.url).href

export default {
  type: 'pie-chart',
  description: 'ChartJS - pie chart',
  icon: icon,
  group: 'chartAndGauge',
  /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|3D|facility|storage|conveyance|transport|form|etc */
  model: {
    type: 'chartjs',
    top: 0,
    left: 0,
    width: 200,
    height: 200,
    chart: {
      type: 'pie',
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
            borderWidth: 0,
            dataKey: 'value'
          }
        ],
        labelDataKey: 'label'
      },
      options: {
        theme: 'dark',
        legend: {
          display: true,
          position: 'top'
        },
        animation: {
          animateScale: true
        }
      }
    },
    data: [
      {
        label: 'A',
        value: 80
      },
      {
        label: 'B',
        value: 15
      },
      {
        label: 'C',
        value: 15
      }
    ]
  }
}
